import React from 'react';
import PropTypes from 'prop-types';

import JournalEntry from './components/JournalEntry';
import StyledCard from "../card/StyledCard";

Journal.propTypes = {
    title: PropTypes.any,
    entries: PropTypes.array
};

function Journal({title = null, entries = []}) {
    return (
        <StyledCard style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            boxSizing: 'border-box',
        }}>
            <p style={{
                fontSize: '11px',
                fontWeight: '700',
                color: '#9ca3af',
                textTransform: 'uppercase',
                margin: '0 0 20px 0',
            }}>
                {title}
            </p>
            <div style={{overflowY: 'auto', flex: 1}}>
                {entries.map((entry, index) => (
                    <JournalEntry
                        key={index}
                        title={entry.title}
                        date={entry.date}
                        type={entry.type}
                    />
                ))}
            </div>
        </StyledCard>
    );
}

export default Journal;
